// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"54b34345","324":"47b0d954","399":"1f6d1d0b","440":"ef148bcd","455":"988aa77e","480":"aa6f7a65","712":"503ce095","838":"2e86a638","876":"6ff1d385","977":"10efa816"}[chunkId] + ".chunk.js";
};